import React, {useState}from 'react';
import {FaBars, FaTimes,FaGithub,FaLinkedin} from 'react-icons/fa';
import Logo from '../assets/logo.png';
import { HiOutlineMail } from 'react-icons/hi';
import {BsFillPersonLinesFill} from 'react-icons/bs';
import {SiNetlify} from 'react-icons/si';
import {Link} from 'react-scroll'


const Navbar = () => {
    const [nav, setNav] = useState(false)
    const handleClick = () => setNav(!nav)

    
  return (
    <div className='Fixed w-full h-[80px] flex justify-between items-center px-4 bg-[#0a192f] text-gray-300 '>
        <div>
        <img src={Logo} alt="" style={{width: '50px'}} />
        </div>
        {/* Menu */}
        
            <ul className=' hidden md:flex'>
                <li>
                <Link  to="home"  smooth={true}  duration={500} >
                Home
                </Link>
                </li>
                <li>
                <Link  to="about"  smooth={true}  duration={500} >
                About
                </Link>
                </li>
                <li>
                <Link  to="skills"  smooth={true}  duration={500} >
                Skills
                </Link>
                </li>
                <li>
                <Link  to="work"  smooth={true}  duration={500} >
                Work
                </Link>
                </li>
                <li>
                <Link  to="contact"  smooth={true}  duration={500} >
                Contact
                </Link>
                </li>
            </ul>
       
        {/* Hamburger */}
        <div onClick={handleClick} className='md:hidden z-10'>
            {!nav ? <FaBars /> : <FaTimes/>}
        </div>
        {/* Mobile menu */}

        <ul className= {!nav ? 'hidden' : 'absolute top-0 left-0 w-full h-screen bg-[#0a192f] flex flex-col justify-center items-center'} >
               <a href="home"><li className='py-6 text-4xl'>
               <Link onClick={handleClick} to="home"  smooth={true}  duration={500} >
                Home
                </Link></li></a>
                <li className='py-6 text-4xl'>
                <Link  onClick={handleClick} to="about"  smooth={true}  duration={500} >
                About
                </Link>
                </li>
                <li className='py-6 text-4xl'>
                <Link onClick={handleClick} to="skills"  smooth={true}  duration={500} >
                Skills
                </Link>
                </li>
                <li className='py-6 text-4xl'>
                <Link onClick={handleClick} to="work"  smooth={true}  duration={500} >
                Work
                </Link>
                </li>
                <li className='py-6 text-4xl'>
                <Link onClick={handleClick} to="contact"  smooth={true}  duration={500} >
                Contact
                </Link>
                </li>
                
            </ul> 

        {/* social icons */}
        <div className=' hidden lg:flex fixed flex-col top-[35%] left-0'>
            <ul>
                <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-500 bg-blue-600'>
                    <a className='flex justify-between items-center w-full text-gray-300' 
                    href= "https://www.linkedin.com/in/dubard-jones-9824781b2?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3Bnz0dkS8xQYqrZRGlwO9zsw%3D%3D">
                    Linkedin <FaLinkedin size={30} />
                </a>
                </li>
                <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-500 bg-black'>
                    <a className='flex justify-between items-center w-full text-gray-300' 
                    href="https://github.com/Wgang231">
                    Github <FaGithub size={30} />
                </a>
                </li>
                <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-500 bg-red-600'>
                    <a className='flex justify-between items-center w-full text-gray-300' 
                    href="https://www.samajonesd1997@gmail.com">
                    Email <HiOutlineMail size={30} />
                </a>
                </li>
                <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-500 bg-zinc-700 '>
                    <a className='flex justify-between items-center w-full text-gray-300' 
                    href="https://app.netlify.com/teams/wgang231/overview">
                    Netlify <SiNetlify size={30} />
                </a>

                </li>
                <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-500 bg-green-600'>
                    <a className='flex justify-between items-center w-full text-gray-300' 
                    href="https://docs.google.com/document/d/e/2PACX-1vQKwU0SXcOQeL4PKA7SLf6_ehgEC5s7nOO281aGJe6KlQ4zEWLlGTcXBtcmauQ3bGZBwCyJ1prnobWR/pub">
                    Resume <BsFillPersonLinesFill size={30} />
                </a>
                </li>
            </ul>
        </div>
    </div>
  )
}

export default Navbar 